export const RECEIVED_NOTIFICATION = "RECEIVED_NOTIFICATION";
export const NEW_NOTIFICATIONS = "NEW_NOTIFICATIONS";
export const LOAD_NEW_NOTIFICATIONS = "LOAD_NEW_NOTIFICATIONS";
export const SET_SHOW_NOTIFICATION_PERMISSION_MODAL =
  "SET_SHOW_NOTIFICATION_PERMISSION_MODAL";
export const NOTIFICATION_TITLE = "NOTIFICATION_TITLE";
export const SET_SHOW_HUDDLE_NOTIFICATION = "SET_SHOW_HUDDLE_NOTIFICATION";
export const SET_SHOW_KICK_NOTIFICATION = "SET_SHOW_KICK_NOTIFICATION";
